import { Box, Typography, Grid } from "@material-ui/core";

import { ShaDowBox } from "../../../../../components/boxes";
import { Icon } from "../../../../../components/base";
import DoubleCircleImg from "../../../../../assets/images/icons/double-circle.svg";
import OwnerImg from "../../../../../assets/images/icons/owner.svg";

export const CentralMeterNoSubMeters = () => {

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: "24px 24px 64px" }}>
        <Typography variant="h4">Central meter, no sub-meters</Typography>
        <Grid container style={{ marginTop: 50 }}>
          <Grid item sm={6} style={{ borderRight: "1px solid rgba(88, 88, 88, 0.25)", paddingBottom: 20 }}>
            <Icon
              src={DoubleCircleImg}
              style={{
                display: "block",
                width: 100,
                height: 100,
                margin: "0 auto",
                marginBottom: 30
              }}
            />
            <Typography variant="h2" style={{ textAlign: "center" }}>1</Typography>
            <Typography style={{ textAlign: "center" }}>Meter</Typography>
          </Grid>
          <Grid container item sm={6} justifyContent="center" style={{ paddingBottom: 20 }}>
            <Icon
              src={OwnerImg}
              style={{
                marginBottom: 30
              }}
            />
            <Typography style={{ maxWidth: 135, textAlign: "center" }}>
              Owned by Building  Owner
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </ShaDowBox>
  )
}
